import type { SVGProps } from 'react';

import * as styles from './SBusLogo.css';

interface SBusLogoProps extends SVGProps<SVGSVGElement> {
  theme: 'purple' | 'white';
}

export const SBusLogo = ({ theme, ...props }: SBusLogoProps) => {
  const themeClasses =
    theme === 'purple'
      ? styles.darkForegroundTheme
      : styles.lightForegroundTheme;

  return (
    <svg
      {...props}
      data-testid="sbusLogo"
      className={props.className}
      x="0px"
      y="0px"
      viewBox="23.184 23.217 331.5 66.333"
      enableBackground="new 23.184 23.217 331.5 66.333"
      // xml:space="preserve"
    >
      <path
        className={themeClasses.letteringSeek}
        d="M181.9,67.7l-5.8-9.801l-2.5,2.801v7h-5.9V35.6h5.9v18.2l7.8-9.6h7.1l-8.4,9.5l9,14H181.9z"
      />
      <path
        className={themeClasses.letteringSeek}
        d="M108.2,68c-3.7,0-7-0.4-10-3.4l3.8-3.8c1.9,1.9,4.5,2.2,6.3,2.2c2,0,4.1-0.7,4.1-2.4c0-1.2-0.6-2-2.5-2.2L106.2,58c-4.2-0.4-6.9-2.3-6.9-6.601c0-4.899,4.3-7.5,9.1-7.5c3.7,0,6.7,0.601,9,2.801l-3.6,3.699c-1.4-1.199-3.4-1.6-5.5-1.6c-2.3,0-3.3,1.1-3.3,2.3c0,0.9,0.4,1.8,2.4,2l3.7,0.4c4.6,0.5,7,2.899,7,6.899C118.2,65.5,113.8,68,108.2,68z"
      />
      <path
        className={themeClasses.letteringSeek}
        d="M126.1,57.8c0,3,1.9,5.2,5.1,5.2c2.6,0,3.8-0.7,5.3-2.2l3.6,3.5c-2.4,2.4-4.7,3.7-8.9,3.7c-5.5,0-10.9-2.5-10.9-12c0-7.7,4.1-12,10.2-12c6.5,0,10.2,4.8,10.2,11.2v2.6H126.1z M134.5,51.3c-0.6-1.4-1.9-2.4-3.9-2.4s-3.3,1-3.9,2.4c-0.4,0.9-0.5,1.5-0.5,2.5h8.9C135,52.8,134.9,52.1,134.5,51.3z"
      />
      <path
        className={themeClasses.letteringSeek}
        d="M149.2,57.8c0,3,1.9,5.2,5.1,5.2c2.6,0,3.8-0.7,5.3-2.2l3.6,3.5c-2.4,2.4-4.7,3.7-8.9,3.7c-5.5,0-10.9-2.5-10.9-12c0-7.7,4.2-12,10.2-12c6.5,0,10.2,4.8,10.2,11.2v2.6H149.2z M157.6,51.3c-0.6-1.4-1.9-2.4-3.9-2.4s-3.3,1-3.9,2.4c-0.4,0.9-0.5,1.5-0.5,2.5h8.9C158.1,52.8,158,52.1,157.6,51.3z"
      />
      <path
        className={themeClasses.ring}
        d="M24,56.4c0-18,14.6-32.5,32.5-32.5C74.5,23.9,89,38.5,89,56.4c0,18-14.6,32.5-32.5,32.5S24,74.4,24,56.4L24,56.4z"
      />
      <path
        className={themeClasses.element}
        d="M57.3,36.3c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2s-0.9,2-2,2C58.2,38.3,57.3,37.4,57.3,36.3L57.3,36.3z"
      />
      <path
        className={themeClasses.element}
        d="M63.6,43.1c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2C64.6,45.4,63.6,44.4,63.6,43.1L63.6,43.1z"
      />
      <path
        className={themeClasses.element}
        d="M57.3,43.1c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.101-0.9,2-2,2C58.2,45.2,57.3,44.3,57.3,43.1L57.3,43.1z"
      />
      <path
        className={themeClasses.element}
        d="M70.4,50c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5c0,1.399-1.1,2.5-2.5,2.5S70.4,51.4,70.4,50L70.4,50z"
      />
      <path
        className={themeClasses.element}
        d="M63.6,50c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2C64.6,52.2,63.6,51.2,63.6,50L63.6,50z"
      />
      <path
        className={themeClasses.element}
        d="M57.3,50c0-1.101,0.9-2,2-2c1.1,0,2,0.899,2,2c0,1.1-0.9,2-2,2C58.2,52,57.3,51.1,57.3,50L57.3,50z"
      />
      <path
        className={themeClasses.element}
        d="M51.3,50c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8s-0.8,1.8-1.8,1.8C52.1,51.7,51.3,51,51.3,50L51.3,50z"
      />
      <path
        className={themeClasses.element}
        d="M46.2,50c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5C46.9,51.5,46.2,50.8,46.2,50L46.2,50z"
      />
      <path
        className={themeClasses.element}
        d="M41.4,50c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3C42,51.2,41.4,50.7,41.4,50L41.4,50z"
      />
      <path
        className={themeClasses.element}
        d="M37.4,50c0-0.601,0.5-1,1-1c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1C37.8,51,37.4,50.5,37.4,50L37.4,50z"
      />
      <path
        className={themeClasses.element}
        d="M33.5,50c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8c0,0.399-0.3,0.8-0.8,0.8C33.9,50.7,33.5,50.4,33.5,50L33.5,50z"
      />
      <path
        className={themeClasses.element}
        d="M30.3,50c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5C30.5,50.5,30.3,50.3,30.3,50L30.3,50z"
      />
      <path
        className={themeClasses.element}
        d="M70.4,56.8c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5S70.4,58.2,70.4,56.8L70.4,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M63.6,56.8c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2S67,59,65.8,59C64.6,59,63.6,58,63.6,56.8L63.6,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M57.3,56.8c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2s-0.9,2-2,2C58.2,58.8,57.3,57.9,57.3,56.8L57.3,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M51.3,56.8c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8s-0.8,1.8-1.8,1.8S51.3,57.8,51.3,56.8L51.3,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M46.2,56.8c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5C46.9,58.3,46.2,57.6,46.2,56.8L46.2,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M41.4,56.8c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3C42,58.1,41.4,57.5,41.4,56.8L41.4,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M37.4,56.8c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1C37.8,57.8,37.4,57.4,37.4,56.8L37.4,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M33.5,56.8c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8C33.9,57.6,33.5,57.2,33.5,56.8L33.5,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M30.3,56.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5C30.5,57.3,30.3,57.1,30.3,56.8L30.3,56.8z"
      />
      <path
        className={themeClasses.element}
        d="M77.3,56.9c0-1.5,1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8c0,1.5-1.2,2.801-2.8,2.801C78.5,59.6,77.3,58.4,77.3,56.9L77.3,56.9z"
      />
      <path
        className={themeClasses.element}
        d="M70.4,63.6c0-1.399,1.1-2.5,2.5-2.5s2.5,1.101,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5C71.5,66.2,70.4,65,70.4,63.6L70.4,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M63.6,63.6c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2C64.6,65.9,63.6,64.9,63.6,63.6L63.6,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M57.3,63.6c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.101-0.9,2-2,2C58.2,65.7,57.3,64.8,57.3,63.6L57.3,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M51.3,63.6c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8s-0.8,1.8-1.8,1.8S51.3,64.6,51.3,63.6L51.3,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M46.2,63.6c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5C46.9,65.2,46.2,64.5,46.2,63.6L46.2,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M41.4,63.6c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3C42,64.9,41.4,64.3,41.4,63.6L41.4,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M37.4,63.6c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1s-0.5,1-1,1C37.8,64.6,37.4,64.2,37.4,63.6L37.4,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M33.5,63.6c0-0.399,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8C33.9,64.4,33.5,64.1,33.5,63.6L33.5,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M30.3,63.6c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5C30.5,64.1,30.3,63.9,30.3,63.6L30.3,63.6z"
      />
      <path
        className={themeClasses.element}
        d="M63.6,70.5c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2C64.6,72.7,63.6,71.7,63.6,70.5L63.6,70.5z"
      />
      <path
        className={themeClasses.element}
        d="M57.3,70.5c0-1.101,0.9-2,2-2c1.1,0,2,0.899,2,2c0,1.1-0.9,2-2,2C58.2,72.5,57.3,71.6,57.3,70.5L57.3,70.5z"
      />
      <path
        className={themeClasses.element}
        d="M57.3,77.3c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2s-0.9,2-2,2C58.2,79.3,57.3,78.4,57.3,77.3L57.3,77.3z"
      />
      <g>
        <path
          className={themeClasses.letteringBusiness}
          d="M209.299,65.9c-1.199,1.2-3.299,2-5.699,2c-2.6,0-4.7-0.6-6.6-3.1v2.8h-3.4V33.7h3.4V46.9c1.899-2.399,4.1-3,6.6-3c2.4,0,4.5,0.801,5.699,2c2.4,2.4,2.9,6.301,2.9,10C212.2,59.6,211.7,63.5,209.299,65.9z M202.9,46.9c-5.101,0-5.899,4.4-5.899,9c0,4.601,0.799,9,5.899,9s5.899-4.399,5.899-9C208.799,51.3,208,46.9,202.9,46.9z"
        />
        <path
          className={themeClasses.letteringBusiness}
          d="M231.5,67.6V65c-1.701,1.899-4,2.899-6.601,2.899c-2.5,0-4.601-0.8-6.101-2.199C217.1,64.1,216.4,61.8,216.4,59.1v-15h3.399v14.4c0,4.1,2.201,6.2,5.701,6.2s5.899-2.101,5.899-6.2V44.2h3.399v23.5H231.5V67.6z"
        />
        <path
          className={themeClasses.letteringBusiness}
          d="M248,67.9c-4,0-7.101-0.899-9.601-3.399l2.3-2.3c1.9,2,4.4,2.699,7.301,2.699c3.899,0,6.199-1.399,6.199-4.1c0-2-1.199-3.2-3.9-3.4l-3.899-0.3c-4.601-0.399-7-2.399-7-6.3c0-4.3,3.601-6.9,8.601-6.9c3.299,0,6.299,0.801,8.399,2.5l-2.2,2.2C252.5,47.3,250.4,46.7,248,46.7c-3.4,0-5.201,1.5-5.201,3.899c0,2,1.101,3.2,4.101,3.4l3.8,0.3c4.1,0.4,6.9,2,6.9,6.3C257.5,65.3,253.6,67.9,248,67.9z"
        />
        <path
          className={themeClasses.letteringBusiness}
          d="M261.2,37.5v-3.9h3.9v3.9H261.2z M261.4,67.6V44.2h3.399v23.5H261.4V67.6z"
        />
        <path
          className={themeClasses.letteringBusiness}
          d="M285.6,67.6V53.2c0-4.101-2.2-6.2-5.801-6.2c-3.5,0-5.799,2.1-5.799,6.2V67.6h-3.4V44.2h3.4v2.6c1.699-1.9,4-2.9,6.6-2.9c2.5,0,4.6,0.801,6,2.2c1.699,1.601,2.4,3.8,2.4,6.5v15H285.6z"
        />
        <path
          className={themeClasses.letteringBusiness}
          d="M296.6,56.8c0,5.1,2.4,8.1,6.9,8.1c2.699,0,4.299-0.8,6.1-2.699l2.301,2c-2.4,2.399-4.602,3.6-8.602,3.6c-6.199,0-10.199-3.7-10.199-12c0-7.6,3.699-12,9.6-12c6.1,0,9.6,4.4,9.6,11.3V56.7H296.6V56.8z M308.299,50.3c-0.898-2.1-3-3.5-5.5-3.5s-4.6,1.4-5.5,3.5c-0.5,1.3-0.6,2-0.699,3.9H309C308.901,52.3,308.901,51.6,308.299,50.3z"
        />
        <path
          className={themeClasses.letteringBusiness}
          d="M324.299,67.9c-4,0-7.1-0.899-9.6-3.399L317,62.2c1.9,2,4.4,2.699,7.299,2.699c3.9,0,6.201-1.399,6.201-4.1c0-2-1.201-3.2-3.9-3.4l-3.9-0.3c-4.6-0.399-7-2.399-7-6.3c0-4.3,3.6-6.9,8.6-6.9c3.301,0,6.301,0.801,8.4,2.5l-2.199,2.2c-1.701-1.3-3.801-1.899-6.201-1.899c-3.398,0-5.199,1.5-5.199,3.899c0,2,1.1,3.2,4.1,3.4L327,54.3c4.1,0.4,6.9,2,6.9,6.3C333.799,65.3,330,67.9,324.299,67.9z"
        />
        <path
          className={themeClasses.letteringBusiness}
          d="M344.299,67.9c-4,0-7.1-0.899-9.6-3.399L337,62.2c1.9,2,4.4,2.699,7.299,2.699c3.9,0,6.201-1.399,6.201-4.1c0-2-1.201-3.2-3.9-3.4l-3.9-0.3c-4.6-0.399-7-2.399-7-6.3c0-4.3,3.6-6.9,8.6-6.9c3.301,0,6.301,0.801,8.4,2.5l-2.199,2.2c-1.701-1.3-3.801-1.899-6.201-1.899c-3.398,0-5.199,1.5-5.199,3.899c0,2,1.1,3.2,4.1,3.4L347,54.3c4.1,0.4,6.9,2,6.9,6.3C353.901,65.3,350,67.9,344.299,67.9z"
        />
      </g>
    </svg>
  );
};
